import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import Player from "video.js/dist/types/player";
// import "video.js/dist/video-js.css";
import "@videojs/themes/dist/forest/index.css";
import useInView from "utils/hooks/useInView";
// import "video.js/dist/video-js.min.css";

interface VideoJSProps {
    options: any;
    onReady?: (player: Player) => void;
}

export const VideoJS: React.FC<VideoJSProps> = ({ options, onReady }) => {
    const videoRef = useRef<HTMLDivElement>(null);
    // const containerRef = useRef<HTMLDivElement>(null);
    const playerRef = useRef<Player | null>(null);

    useEffect(() => {
        if (!playerRef.current) {
            const videoElement = document.createElement("video-js");
            videoElement.classList.add("vjs-big-play-centered");
            // videoElement.classList.add("vjs-theme-city");
            if (videoRef.current) {
                videoRef.current.appendChild(videoElement);
            }

            const player = (playerRef.current = videojs(
                videoElement,
                options,
                () => {
                    videojs.log("player is ready");
                    if (onReady) {
                        onReady(player);
                    }
                }
            ));
        } else {
            const player = playerRef.current;
            player.autoplay(options.autoplay);
            player.src(options.sources);
        }
    }, [options, onReady]);

    const isInView = useInView(videoRef);

    useEffect(() => {
        const player = playerRef.current;

        return () => {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (playerRef.current) {
            if (isInView) {
                playerRef.current.play();
            } else {
                playerRef.current.pause();
            }
        }
    }, [isInView]);

    // const playVid = () => {
    //     if (!playerRef.current) {
    //         return;
    //     }

    //     playerRef.current.play();
    // };
    // const pauseVid = () => {
    //     if (!playerRef.current) {
    //         return;
    //     }

    //     playerRef.current.pause();
    // };

    return (
        <>
            <div data-vjs-player>
                <div ref={videoRef} />
            </div>
            {/* <button onClick={playVid}>play video</button>
            <button onClick={pauseVid}>pause video</button> */}
        </>
    );
};

export default VideoJS;
